import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

import API, { showNetworkErrorToast } from "Utils/api";
import { updateVdaAction } from ".";
import { refreshTokenAction } from "../appState";
// import { RootState } from "../..";

export const fetchPatchVdaAction = createAsyncThunk<
  void,
  {
    id: string;
    data: Partial<any>; // You may want to define a proper VdaAction type
    successMessage?: string;
  }
>(
  "vdaActions/fetchPatchVdaAction",
  async ({ id, data, successMessage }, thunkAPI) => {
    try {
      // Check if JWT token exists
      const token = window.localStorage.getItem("JWT");
      if (!token) {
        toast.error("Authentication required. Please log in again.");
        return Promise.reject(new Error("No authentication token found"));
      }

      const response = await API.patch(`vda_actions/${id}/`, data);
      thunkAPI.dispatch(updateVdaAction(response.data));

      if (successMessage) {
        toast.success(successMessage);
      }

      return response.data;
    } catch (error: any) {
      // Handle authentication errors specifically
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        const token = window.localStorage.getItem("JWTrefresh");
        if (token) {
          try {
            // Attempt to refresh the token
            await thunkAPI.dispatch(
              refreshTokenAction(() => {
                toast.error("Session expired. Please log in again.");
              })
            );

            // Retry the original request after token refresh
            const retryResponse = await API.patch(`vda_actions/${id}/`, data);
            thunkAPI.dispatch(updateVdaAction(retryResponse.data));

            if (successMessage) {
              toast.success(successMessage);
            }

            return retryResponse.data;
          } catch (refreshError) {
            toast.error("Session expired. Please log in again.");
            return Promise.reject(refreshError);
          }
        } else {
          toast.error("Authentication expired. Please log in again.");
          return Promise.reject(new Error("Authentication expired"));
        }
      }

      showNetworkErrorToast(error);
      return Promise.reject(error);
    }
  }
);
